import { render } from "./StartView.vue?vue&type=template&id=5d03ec79&scoped=true"
import script from "./StartView.vue?vue&type=script&lang=js"
export * from "./StartView.vue?vue&type=script&lang=js"

import "./StartView.vue?vue&type=style&index=0&id=5d03ec79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d03ec79"]])

export default __exports__